import * as React from 'react'
import { useTheme } from '@mui/material/styles'
import { Box, Link, Typography } from '@mui/material'
import local from '../../assets/images/local.svg'
import { useDispatch, useSelector } from 'react-redux'
import buildServiceList, { type IPlan, type IServicesList } from '../../utils/serviceList'
import { openCategory } from '../../redux/features/productCategoriesSlice'
import { type IProduct, type ISubscription } from '../../redux/api/types'
import { isLocalPresenceCountry } from '../../utils/isLocalPresenceCountry'
import { STRIPE_CATEGORY } from '../../utils/constants/stripe'

function findProductByName (products: any[], name: string | null | undefined): IProduct | null {
  if (!name) return null
  for (let i = 0, len = products.length; i < len; i++) {
    if (products[i].name === name) {
      return products[i]
    }
  }
  return null
}

function filterProducts (products: IProduct[], isLocalPresenceCountry: boolean, subscriptions?: ISubscription[]): IProduct[] | null {
  if (!products) return null
  const result = []
  for (let i = 0, len = products.length; i < len; i++) {
    if (!isLocalPresenceCountry && (products[i].category === STRIPE_CATEGORY.LOCAL_PRESENCE)) {
      continue
    }
    if (!products[i].upsellText) {
      continue
    }
    if (subscriptions?.find((subscription: ISubscription) => subscription.product === products[i].id)) {
      continue
    }
    result.push(products[i])
  }
  return result
}

function getAllPlans (servicesList: IServicesList[]): IPlan[] {
  const plans: IPlan[] = []
  servicesList.forEach(element => {
    element.plans.forEach(plan => {
      plans.push(plan)
    })
  })
  return plans
}

function findServiceByProduct (servicesList: IServicesList[], product: IProduct | null): IServicesList | null {
  if (!product) return null

  for (let s = 0, len = servicesList.length; s < len; s++) {
    for (let p = 0, len = servicesList[s].plans.length; p < len; p++) {
      if (servicesList[s].plans[p].productId === product?.id) {
        return servicesList[s]
      }
    }
  }
  return null
}

const Offer: React.FC = () => {
  const theme = useTheme()
  const userState = useSelector((state: any) => state.userState)
  const { products, prices, subscriptions, user } = userState
  const filtredProducts = filterProducts(products, isLocalPresenceCountry(user), subscriptions)
  const servicesList = buildServiceList(filtredProducts, prices, subscriptions)
  const plans = getAllPlans(servicesList)

  const [planNumber, setPlanNumber] = React.useState(-1)
  if (plans.length && planNumber === -1) {
    setPlanNumber(Math.floor(Math.random() * plans.length))
  }

  const product = (planNumber >= 0) && (planNumber < plans.length) && plans[planNumber]
    ? findProductByName(products, plans[planNumber].name)
    : plans.length ? findProductByName(products, plans[0].name) : null
  const service = findServiceByProduct(servicesList, product)

  const dispatch = useDispatch()
  return (
    <>
      {(servicesList && product && service)
        ? <Box
          sx={{
            alignItems: 'top',
            border: '1px solid #E8E8E8',
            borderRadius: '5px',
            boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            gap: '18px',
            m: '20px 0 0',
            p: '24px 21px'
          }}>
            <Box
              component="img"
              src={local}
              alt="local"
              sx={{ height: '59px', width: '59px' }}
            />
            <Box>
              <Typography sx={{ color: theme.palette.grey[40], fontWeight: 500, lineHeight: '24px', mb: 1 }} variant='h5'>
                Add {product.name}!
              </Typography>
              <Typography sx={{ color: theme.palette.grey[40], fontWeight: 400, lineHeight: '20px', mb: '10px' }} variant='h5'>
                {product.upsellText}
              </Typography>
              <Link sx={{ color: '#919EB6', fontSize: 14, fontWeight: 400 }} onClick={() => dispatch(openCategory(service.title))}>View Options</Link>
            </Box>
          </Box>
        : null
      }
    </>
  )
}

export default Offer
